import {
  createContext,
  useContext,
  useMemo,
  type FC,
  type ReactNode,
} from 'react';

import { useParams } from 'react-router-dom';

interface SandboxContextType {
  selectedSandbox: string;
  gameCode: string;
  studioCode: string;
}

const SandboxContext = createContext<SandboxContextType | undefined>(undefined);

interface SandboxProviderProps {
  children: ReactNode;
}

export const SandboxProvider: FC<SandboxProviderProps> = ({ children }) => {
  const { studioCode, gameCode, sandboxCode } = useParams<{
    studioCode: string;
    gameCode: string;
    sandboxCode: string;
  }>();
  if (!studioCode || !gameCode || !sandboxCode) {
    throw new Error('Studio, game and sandbox codes are required'); //developer error, should never happen
  }

  const value = useMemo<SandboxContextType>(
    () => ({
      selectedSandbox: sandboxCode,
      gameCode,
      studioCode,
    }),
    [sandboxCode, gameCode, studioCode],
  );

  return (
    <SandboxContext.Provider value={value}>{children}</SandboxContext.Provider>
  );
};

export const useSandboxContext = (): SandboxContextType => {
  const context = useContext(SandboxContext);
  if (context === undefined) {
    throw new Error('useSandboxContext must be used within a SandboxProvider');
  }
  return context;
};
